import { getInvoiceDataExportUrl } from '@/services/billing';
import { downloadFileFromURL } from '@/utils/download';

export default async function exportInvoiceData(type: string, dateFrom: string, dateTo: string) {
  const { data: { url } } = await getInvoiceDataExportUrl(type, dateFrom, dateTo);

  downloadFileFromURL(url);
}
